var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 13.397C9.16667 14.0062 8.67281 14.5 8.06367 14.5L8 14.5C6.98745 14.5 6.16667 13.6792 6.16667 12.6667L6.16667 9.83333L3.49073 9.83333C2.12786 9.83333 1.24142 8.39912 1.85092 7.18013L4.18426 2.51346C4.49482 1.89234 5.12961 1.5 5.82407 1.5L8.50254 1.5C8.65252 1.5 8.80177 1.51844 8.94699 1.55467L11.3949 2.16667L12.6667 2.16667C13.6792 2.16667 14.5 2.98745 14.5 4L14.5 8C14.5 9.01255 13.6792 9.83333 12.6667 9.83333L11.1565 9.83333L9.48783 12.3364C9.27841 12.6504 9.16667 13.0195 9.16667 13.397ZM11.8047 8.83333L12.6667 8.83333C13.1269 8.83333 13.5 8.46025 13.5 8L13.5 4C13.5 3.53975 13.1269 3.16667 12.6667 3.16667L11.8333 3.16667L11.8333 8.66667C11.8333 8.72374 11.8236 8.78008 11.8047 8.83333ZM10.8333 3.05705L8.70488 2.52492C8.6385 2.50836 8.57055 2.5 8.50253 2.5L5.82407 2.5C5.50839 2.5 5.21985 2.67833 5.07868 2.96067L2.74535 7.62734C2.46831 8.18141 2.87121 8.83333 3.49073 8.83333L8 8.83333C8.27614 8.83333 8.5 9.05719 8.5 9.33333C8.5 9.60948 8.27614 9.83333 8 9.83333L7.16667 9.83333L7.16667 12.6667C7.16667 13.1269 7.53975 13.5 8 13.5L8.06367 13.5C8.12052 13.5 8.16667 13.4539 8.16667 13.397C8.16667 12.8221 8.33681 12.26 8.6558 11.7816L10.8333 8.51528L10.8333 3.05705Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumbDown.d18e63b1.svg";
export { ForwardRef as ReactComponent };